import { render } from "./colorAccordion.vue?vue&type=template&id=570892a8"
import script from "./colorAccordion.vue?vue&type=script&lang=js"
export * from "./colorAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__